import { render } from "./CursorMove.vue?vue&type=template&id=0abcb943"
import script from "./CursorMove.vue?vue&type=script&lang=js"
export * from "./CursorMove.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CursorMove.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0abcb943"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0abcb943', __exports__)) {
    api.reload('0abcb943', __exports__)
  }
  
  module.hot.accept("./CursorMove.vue?vue&type=template&id=0abcb943", () => {
    api.rerender('0abcb943', render)
  })

}


export default __exports__